// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"_1Ffb2BbiUuuumOhIB6ypBJ","open":"_32P8TUb7WvjkG6cfDkxaZO"};